/* GASSISA
=========================================================================================
* Descripción: Almacén central de credenciales de sesión de usuario SizeSoftX Tenant.
*              Único propietario de las claves físicas de sesión en localStorage.
*              No administra activación/licenciamiento/dispositivo (arsync-*): el logout
*              de usuario conserva el Tenant activado.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 22/09/2026 | Lic. José Luis Aragón Cervantes  | Creación: centralizar claves y acceso a sesión
* ---------------------------------------------------------------------------------------
*/

export const tokenName = "sizesoftx-dashboard-token";
export const tokenRefreshName = "sizesoftx-dashboard-tokenRefresh";
export const tenantAccessTokenName = "sizesoftx-tenant-access-token";

const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {}
};

const safeRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch {}
};

export const getSession = () => {
  const accessToken = safeGet(tokenName);
  const refreshToken = safeGet(tokenRefreshName);
  const tenantAccessToken = safeGet(tenantAccessTokenName);
  return { accessToken, refreshToken, tenantAccessToken };
};

export const saveSession = ({ accessToken, refreshToken, tenantAccessToken } = {}) => {
  // Misma semántica que saveLoginResponse histórico: JWT y RefreshToken siempre se
  // escriben; el TenantAccessToken/JWE solo cuando la respuesta lo incluye.
  safeSet(tokenName, accessToken);
  safeSet(tokenRefreshName, refreshToken);
  if (tenantAccessToken) {
    safeSet(tenantAccessTokenName, tenantAccessToken);
  }
};

export const clearUserSession = () => {
  // Cierra la sesión de USUARIO. Conserva deliberadamente el TenantAccessToken/JWE
  // y los datos arsync-* (dispositivo/activación/licencia): el Tenant permanece activado.
  safeRemove(tokenName);
  safeRemove(tokenRefreshName);
};

export const hasUserSession = () => {
  const { accessToken, refreshToken } = getSession();
  return !!accessToken && !!refreshToken;
};

export const getAuthorizationToken = (stateToken = "") =>
  safeGet(tenantAccessTokenName) || stateToken || safeGet(tokenName) || "";
